export default __webpack_public_path__ + "static/media/icon5.4cb095f9.svg";